import { useIsAvaBasePath } from '@/app/hooks/ava/useAvaVerification'
import { useUrlSearchParam } from '@/hooks'
import FleetUtils from '@/utils/fleet-utils/FleetUtils'
import { trackConnectionStarted } from '@/logging/segment'

export function useTeslaFleetAuthRedirect(
  deviceType: 'vehicle' | 'energy_system' = 'vehicle',
) {
  const isAva = useIsAvaBasePath()
  const isOnboarding = useUrlSearchParam('onboarding')
  const { url } = FleetUtils.useFleetAuthUrl(deviceType)

  const redirectToTeslaAuth = () => {
    const trackingDeviceType =
      deviceType === 'energy_system' ? 'utility' : deviceType
    trackConnectionStarted(trackingDeviceType, 'tesla')

    if (isAva) {
      const teslaAuthUrl = new URL(url)
      const state = teslaAuthUrl.searchParams.get('state')
      const base64State = btoa(
        JSON.stringify({ utility: 'ava', onboarding: isOnboarding, state }),
      )
      teslaAuthUrl.searchParams.set('state', base64State)
      window.location.href = teslaAuthUrl.toString()
      return
    }

    window.location.href = url
  }

  return { redirectToTeslaAuth }
}
